import { connect } from "react-redux";

import HelpMenu from "../Components/header/HelpMenu";
import { SetLocale } from "../store/actions/actions";
const mapStateToProps = (state) => {
  return {
    locale: state.locale,
  };
};

const mapDispatchToProps = {
  SetLocale,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpMenu);
